package fr.frux.core.designsystem.theme

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Shapes
import androidx.compose.ui.unit.dp

object FruxSpacing {
    val xs = 4.dp
    val sm = 8.dp
    val md = 16.dp
    val lg = 24.dp
    val xl = 32.dp
    val xxl = 48.dp
}

// Rayons généralisés (#198) : small/medium relevés pour un rendu plus organique, large/extraLarge
// déjà au niveau cible — inchangés pour ne pas régresser. Les boutons pill (RoundedCornerShape(50))
// sont un shape ad hoc hors de cette table, non concernés.
internal val FruxShapes = Shapes(
    extraSmall = RoundedCornerShape(6.dp),
    small = RoundedCornerShape(12.dp),
    medium = RoundedCornerShape(16.dp),
    large = RoundedCornerShape(20.dp),
    extraLarge = RoundedCornerShape(28.dp),
)
